import React, {Component} from 'react';
import {Button, Col, Modal, ModalBody, ModalHeader, Row, FormGroup, Label} from 'reactstrap';
import FormBool from './FormBool.js';
import FormText from './FormText.js';
import FormSelect from './FormSelect.js';
import PropNumSelector from './PropNumSelector.js';

const USER_TEMPLATE = {
	user: {
		email:         '',
		id:            0,
		has_2fa:       false,
		has_2fa_setup: false
	},

	permission_group: {
		id:   0,
		name: ''
	},

	properties: []
};

const ROLLER_PREFIX = process.env.REACT_APP_ROLLER_PREFIX;
const SESSION_KEY = process.env.REACT_APP_SESSION_KEY;

class UserForm extends Component {
	constructor(props) {
		// Props = {user, allPermissionGroups, allPropertyNumbers}
		super(props);
		let nextRecord = props.record;
		if (!nextRecord.property_number_list) {
			nextRecord.property_number_list = [];
		}

		this.state = {
			loading: false,
			record:  nextRecord
		};

		this.toggleLoader = this.toggleLoader.bind(this);
		this.updatePropertyArray = this.updatePropertyArray.bind(this);
		this.updateForm = this.updateForm.bind(this);
	}


    toggleLoader = () => {
    	let {loading} = this.state;
    	this.setState({loading: !loading});
    }

    makeUserBool(props) {
    	let {colsize, humanLabel, onChangeHandler, onChangeKey, value} = props;
    	let nextValue = !value;
    	return (
    		<Col xs={colsize}>
    			<FormGroup>
    				<Label
    					className="simpleLabel"
    					for={`${this.props.parentID}-${this.props.label}`}
    				>
    					{humanLabel}{' '}
    				</Label>
    				<label className="switch">
    					<div className="switchText">
    						<div className="switchLft">Yes</div>
    						<div className="switchRt">No</div>
    					</div>
    					<input
    						type="checkbox"
    						checked={value}
    						id={`${this.props.parentID}-${this.props.label}`}
    						onChange={() => {
    							onChangeHandler(onChangeKey, nextValue);
    						}}
    					/>
    					<span className="slider" />
    				</label>
    			</FormGroup>
    		</Col>
    	);
    }

    makeModalHeader() {
    	let headerText = 'Edit Existing User';
    	if (this.state.record.user.id === 0) {
    		headerText = 'Create New User';
    	}

    	return (
    		<div className="modalHeader">
    			<div className="h5">{headerText}</div>
    			<div className="modalHeaderBtn">
    				<Button color="danger" className="button" onClick={this.props.toggleModal}>Close!</Button>
    			</div>
    		</div>
    	);
    }

    updateForm(targetKey, nextValue) {
    	if (!targetKey || typeof targetKey !== 'string') {
    		console.error(`Expected key to contain a string for object access. Recieved: ${targetKey}`);
    		return;
    	}

    	let nextRecord = Object.assign({}, this.state.record);
    	switch (targetKey) {
    	case 'email':
    	case 'has_2fa':
    	case 'has_2fa_setup':
    		nextRecord.user[targetKey] = nextValue;
    		break;
    	case 'permission_group':
    		nextRecord = this.updatePermissionGroup(nextRecord, nextValue);
    		break;
    	default:
    		console.error(`Could not find ${targetKey} in User`);
    	}

    	return this.setState({record: nextRecord});
    }

    updatePermissionGroup(nextRecord, nextValue) {
    	let val = 0;
    	try {
    		val = parseInt(nextValue);
    	} catch (err) {
    		console.error(`COULD NOT PARSE INT FROM ${nextValue}, err: ${err}`);
    		return nextRecord;
    	}

    	if (val === 0) {
    		nextRecord.permission_group = {id: 0};
    		return nextRecord;
    	}


    	for (let i = 0, x = this.props.allPermissionGroups.length; i < x; i++) {
    		let pg = this.props.allPermissionGroups[i];
    		if (pg.id === val) {
    			nextRecord.permission_group = pg;
    			break;
    		}
    	}


    	return nextRecord;
    }

    updatePropertyArray(nextValues) {
    	let nextRecord = Object.assign({}, this.state.record);

    	for (let i = 0, x = nextValues.length; i < x; i++) {
    		let value = nextValues[i];

    		let found = false;

    		for (let j = 0, y = nextRecord.property_number_list.length; j < y; j++) {
    			let property = nextRecord.property_number_list[j];
    			if (property.record.property_number === value) {
    				found = true;
    				property.persisted = true;
    				nextRecord.property_number_list[j] = property;
    				break;
    			}
    		}

    		if (!found) {
    			let nextEntry = {
    				record: {
    					id:              0,
    					property_number: value
    				},

    				initial:   false,
    				persisted: true
    			};

    			nextRecord.property_number_list.push(nextEntry);
    		}
    	}

    	for (let i = 0, x = nextRecord.property_number_list.length; i < x; i++) {
    		let property = nextRecord.property_number_list[i];

    		let found = false;

    		for (let j = 0, y = nextValues.length; j < y; j++) {
    			let value = nextValues[j];
    			if (property.record.property_number === value) {
    				found = true;
    				break;
    			}
    		}

    		if (!found) {
    			property.persisted = false;
    			nextRecord.property_number_list[i] = property;

    			if (!property.initial) {
    				// This would be a property both added and removed by the user without sending to the DB.
    				nextRecord.property_number_list.splice(i, 1);
    			}
    		}
    	}

    	this.setState({record: nextRecord});
    }

    makeCreateBody() {
    	let button = (<Button color="warning" className="button">Loading...</Button>);

    	if (!this.state.loading) {
    		button = (
    			<Button
    				color="success"
    				className="button"
    				onClick={() => {
    					let nextEmail = this.state.record.user.email;
    					if (!nextEmail) {
    						return window.alert('Cannot have a user with no email.');
    					}
    					let emailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    					if (!nextEmail.match(emailFormat)) {
    						return window.alert('Please enter a valid email address');
    					}
    					this.toggleLoader();
    					this.props.toggleLoader();

    					let postBody = JSON.stringify({
    						email: nextEmail
    					});

    					let createURL = `${ROLLER_PREFIX}/create/`;

    					fetch(createURL, {
    						method:  'POST',
    						headers: {
    							'Content-Type': 'application/json'
    						},
    						body: postBody
    					}).then((res) => {
    						if (!res.ok) {
    							console.error('Error in Create User:');
    							console.log(res);
    							return false;
    						}

    						return res.json();
    					}).then((maybeJSON) => {
    						this.toggleLoader();
    						this.props.toggleLoader();
    						this.props.toggleModal();
    						if (!maybeJSON) {
    							window.alert('Failed in User Create, please check console for details.');
    							return;
    						}

    						window.alert('Successfully created User');
    						this.setState({user: this.props.user});
							this.props.clearAll();
							return this.updateForm('email', '');
    					});
    				}}
    			>Save</Button>
    		);
    	}

    	return (
    		<ModalBody>
    			<form onSubmit={(e) => {
    				e.preventDefault();
    			}}>
    				<Row>
    					<FormText
    						humanLabel="email"
    						colsize={8}
    						value={this.state.record.user.email}
    						triggerFormValueChange={(evt) => {
    							this.updateForm('email', evt.target.value);
    						}}
    					/>
    				</Row>
    			</form>
    			{button}
    		</ModalBody>
    	);
    }

    makeModalBody() {
    	if (this.state.record.user.id === 0) {
    		return this.makeCreateBody();
    	}

    	let multiOptions = this.props.allProperties.map((propertyNumber) => {
    		return {label: propertyNumber.toString(), value: propertyNumber};
    	});

    	let multiValues = [];

    	this.state.record.property_number_list.forEach((propertyNumber) => {
    		if (propertyNumber.persisted) {
    			multiValues.push({label: propertyNumber.record.property_number.toString(), value: propertyNumber.record.property_number});
    		}
    	});

    	let has2faProps = {
    		colsize:         5,
    		humanLabel:      'Has 2fA',
    		onChangeHandler: this.updateForm,
    		onChangeKey:     'has_2fa',
    		value:           this.state.record.user.has_2fa
    	};

    	let has2faSetupProps = {
    		colsize:         5,
    		humanLabel:      'Has 2fA Setup',
    		onChangeHandler: this.updateForm,
    		onChangeKey:     'has_2fa_setup',
    		value:           this.state.record.user.has_2fa_setup
    	};

    	let has2faBool = this.makeUserBool(has2faProps);
    	let has2faSetupBool = this.makeUserBool(has2faSetupProps);

    	let permissionGroupValueArray = this.props.allPermissionGroups.map((pg) => {
    		let nextPG = {
    			id:    pg.id,
    			value: pg.name
    		};

    		return nextPG;
    	});

    	let button = (<Button color="warning" className="button">Loading...</Button>);
    	if (!this.state.loading) {
    		button = (
    			<Button
    				color="success"
    				className="button"
    				onClick={() => {
    					this.props.toggleLoader();
    					this.toggleLoader();
    					let nextRecord = Object.assign({}, this.state.record);
    					let postBody = JSON.stringify(nextRecord);

    					let updateURL = `${ROLLER_PREFIX}/update/`;
    					fetch(updateURL, {
    						method:  'POST',
    						headers: {
    							'Content-Type': 'application/json'
    						},
    						body: postBody
    					}).then((res) => {
    						if (!res.ok) {
    							console.error('Error in Edit User:');
    							console.log(res);
    							window.alert('Failed in User Edit, please check console for details.');
    							return false;
    						}

    						return res.json();
    					}).then((maybeJSON) => {
    						this.props.toggleLoader();
    						this.toggleLoader();
    						if (!maybeJSON) {
    							return;
    						}
    						this.props.toggleModal();

    						window.alert('Successfully updated User');
							this.props.clearAll();
    					});
    				}}
    			>Save</Button>
    		);

    	}

    	return (
    		<ModalBody>
    			<form onSubmit={(e) => {
    				e.preventDefault();
    			}}>
    				<Row>
    					<FormText
    						humanLabel="email"
    						colsize={8}
    						value={this.state.record.user.email}
    						triggerFormValueChange={(evt) => {
    							this.updateForm('email', evt.target.value);
    						}}
    					/>

    					<Col xs={8}>
    						<PropNumSelector
    							handlePropertyUpdate={this.updatePropertyArray}
    							options={multiOptions}
    							placeholder="please add property numbers here"
    							themeName={this.props.themeName}
    							value={multiValues}
    						/>
    					</Col>

    					{has2faBool}
    					{has2faSetupBool}

    					<FormSelect
    						humanLabel="permissionGroup"
    						colsize={8}
    						valueArray={permissionGroupValueArray}
    						currentValue={this.state.record.permission_group.id}
    						triggerFormValueChange={(evt) => {
    							try {
    								// When going from a value to not a value, there isn't a defualt to prevent.
    								evt.preventDefault();
    							} catch (err) {
    								// console.log(err)
    								return this.updateForm('permission_group', 0);
    							}

    							return this.updateForm('permission_group', evt.target.value);
    						}}
    					/>

    				</Row>
    			</form>
    			{button}
    		</ModalBody>
    	);
    }

    render() {
    	let header = this.makeModalHeader();
    	let body = this.makeModalBody();

    	return (
    		<Modal size="lg" isOpen={true} >
    			{header}
    			{body}
    		</Modal>
    	);
    }
}

export default UserForm;



// WEBPACK FOOTER //
// ./src/components/UserForm.js